// extracted by mini-css-extract-plugin
module.exports = {"abbr":"abbr-CLW1k4qt2A"};